/**
 * Params to create a new instance of User
 */
export interface UserParams {
  image: string | null;
  name: string;
  lastName: string;
  dni: string;
  email: string;
  dateOfBirth?: Date;
  acceptedPolicies?: boolean;
  accepted_communications?: boolean;
  accepted_emails?: boolean;
  adult?: boolean;
  isAdmin?: boolean;
}

export class User {
  readonly image: string | null;
  readonly name: string;
  readonly lastName: string;
  readonly dni: string;
  readonly email: string;
  readonly dateOfBirth?: Date;
  readonly acceptedPolicies?: boolean;
  readonly accepted_communications?: boolean;
  readonly accepted_emails?: boolean;
  readonly adult?: boolean;
  readonly isAdmin?: boolean;
  constructor(params: UserParams) {
    this.image = params.image;
    this.name = params.name;
    this.lastName = params.lastName;
    this.dni = params.dni;
    this.email = params.email;
    this.dateOfBirth = params?.dateOfBirth;
    this.acceptedPolicies = params?.acceptedPolicies;
    this.accepted_communications = params?.accepted_communications;
    this.accepted_emails = params?.accepted_emails;
    this.adult = params?.adult;
    this.isAdmin = params?.isAdmin;
  }
}
